"use client";

import { motion } from "motion/react";
import Link from "next/link";
import { contactUsItems } from "@/data";
import {
  slideUpVariants,
  slideFromLeftVariants,
  createStaggerContainer,
} from "@/lib/animations";

const contactItemsContainer = createStaggerContainer(0.2, 0.15);

export function ContactUs() {
  return (
    <section
      id="contact-us"
      className="relative bg-green-1200 px-5 py-10 sm:py-14 md:px-6 md:py-16 lg:px-10 lg:py-20 xl:py-24"
    >
      <div className="absolute bottom-0 right-0 h-full w-full max-w-[934px] bg-pattern-1 bg-cover bg-center bg-no-repeat mix-blend-soft-light" />
      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="max-w-2xl">
          <motion.div
            className="mb-10"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={slideUpVariants}
          >
            <h2 className="mb-1.5 text-xl font-semibold tracking-copy text-green-1300 md:text-2xl lg:text-[32px]">
              Contact Us
            </h2>
            <p className="text-sm text-green-1400 lg:text-base">
              Have questions? We&apos;re here to help.
              <br /> Reach out to our team anytime.
            </p>
          </motion.div>

          <motion.ul
            className="space-y-10 sm:space-y-4"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={contactItemsContainer}
          >
            {contactUsItems.map((item) => (
              <motion.li
                key={item.id}
                className="flex flex-col gap-2.5 sm:flex-row sm:items-center"
                variants={slideFromLeftVariants}
              >
                <div className="flex size-10 items-center justify-center rounded bg-green-1500">
                  <item.icon />
                </div>

                <ul className="flex flex-col gap-1.5 sm:flex-row sm:items-center sm:gap-2.5">
                  {item.items.map((contact) => (
                    <li
                      key={contact.label}
                      className="sm:border-r sm:border-grey-400 sm:pr-2.5 last:sm:border-r-0 last:sm:pr-0"
                    >
                      <Link
                        href={contact.href}
                        className="text-sm font-medium text-black-100 lg:text-base"
                      >
                        {contact.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </motion.li>
            ))}
          </motion.ul>
        </div>
      </div>
    </section>
  );
}
